var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7 26.4554C30.5752 26.4554 31.4146 26.1275 32.0335 25.5438C32.6523 24.9601 33 24.1685 33 23.343V7.781C33 6.95554 32.6523 6.16389 32.0335 5.5802C31.4146 4.99651 30.5752 4.6686 29.7 4.6686H16.665C16.1131 4.6737 15.5687 4.54817 15.0815 4.30348C14.5943 4.0588 14.18 3.70278 13.8765 3.26802L12.54 1.40058C12.2395 0.970244 11.8305 0.617 11.3495 0.372549C10.8686 0.128097 10.3308 8.48463e-05 9.7845 0H3.3C2.42479 0 1.58542 0.327912 0.966547 0.911601C0.347677 1.49529 0 2.28694 0 3.1124V23.343C0 24.1685 0.347677 24.9601 0.966547 25.5438C1.58542 26.1275 2.42479 26.4554 3.3 26.4554H29.7Z",
    fill: "#565D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.8803L16.4008 11.8803L20 14.8803",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.8803V19.8803",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.d8db639aa71a7ef64d2e3eba42917dac.svg";
export { ForwardRef as ReactComponent };